import { render, staticRenderFns } from "./FriendlyCaptcha.vue?vue&type=template&id=7a77b2b8"
import script from "./FriendlyCaptcha.vue?vue&type=script&lang=ts"
export * from "./FriendlyCaptcha.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports